import { Link } from "react-router-dom";
import { allSpecials } from "@/utils/media";
import SectionHeading from "@/components/feature/SectionHeading";

export default function SpecialStrip() {
  return (
    <section className="w-full bg-background-100/70 py-10 md:py-12">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <SectionHeading
          icon="ri-bookmark-3-line"
          title="主题专题推荐"
          subtitle="按题材与影人精心整理，发现属于你的观影清单"
          moreTo="/special/sp-02"
          moreLabel="更多专题"
        />

        <div className="no-scrollbar -mx-1 flex gap-4 overflow-x-auto px-1 pb-2">
          {allSpecials.map((special) => (
            <Link
              key={special.id}
              to={`/special/${special.id}`}
              className="group flex w-[280px] shrink-0 flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1 md:w-[340px]"
            >
              <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-200">
                <img
                  src={special.cover}
                  alt={`${special.title} 专题封面`}
                  title={`${special.title} - 91av视频专题合集`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
                <span className="absolute bottom-2 left-3 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
                  {special.workIds.length} 部作品
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  {special.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {special.subtitle}
                </p>
                <span className="mt-3 flex items-center gap-1 text-xs font-medium text-accent-600">
                  查看专题
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}